var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as L from "leaflet";
import { Icon, Marker, Polygon, Draggable, DomEvent, Util, DomUtil, Handler, Evented, Polyline, LineUtil, latLng } from "leaflet";
const defaultIconDataUrl = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='25.1'%20height='40.227'%3e%3cdefs%3e%3clinearGradient%20id='b'%3e%3cstop%20offset='0'%20stop-color='${color1}'%20/%3e%3cstop%20offset='1'%20stop-color='${color2}'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='a'%3e%3cstop%20offset='0'%20stop-color='${color3}'%20/%3e%3cstop%20offset='1'%20stop-color='${color4}'%20/%3e%3c/linearGradient%3e%3clinearGradient%20xlink:href='%23a'%20id='c'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(-432.796%20-503.349)'%20x1='445.301'%20y1='541.286'%20x2='445.301'%20y2='503.72'%20/%3e%3clinearGradient%20xlink:href='%23b'%20id='d'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(-341.216%20-503.35)'%20x1='351.748'%20y1='522.774'%20x2='351.748'%20y2='503.721'%20/%3e%3c/defs%3e%3cpath%20fill='%23fff'%20d='M6.329%204.513h12.625v14.5H6.329z'%20/%3e%3cpath%20d='M12.594.55C6.021.55.55%206.241.55%2012.416c0%202.778%201.564%206.308%202.694%208.746l9.306%2017.872%209.262-17.872c1.13-2.438%202.738-5.791%202.738-8.746C24.55%206.241%2019.167.55%2012.594.55zm0%207.155a4.714%204.714%200%200%201%204.679%204.71c0%202.588-2.095%204.663-4.679%204.679-2.584-.017-4.679-2.09-4.679-4.679a4.714%204.714%200%200%201%204.679-4.71z'%20fill='url(%23c)'%20stroke='url(%23d)'%20stroke-width='1.1'%20stroke-linecap='round'%20/%3e%3cpath%20d='M12.581%201.657c-5.944%200-10.938%205.219-10.938%2010.75%200%202.359%201.443%205.832%202.563%208.25l.031.031%208.313%2015.969%208.25-15.969.031-.031c1.135-2.448%202.625-5.706%202.625-8.25%200-5.538-4.931-10.75-10.875-10.75zm0%204.969c3.168.021%205.781%202.601%205.781%205.781%200%203.18-2.613%205.761-5.781%205.781-3.168-.02-5.75-2.61-5.75-5.781%200-3.172%202.582-5.761%205.75-5.781z'%20stroke='%23fff'%20stroke-width='1.1'%20stroke-linecap='round'%20stroke-opacity='.122'%20fill='none'%20/%3e%3c/svg%3e";
const plusIconDataUrl = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%3e%3cg%20transform='matrix(.02604%200%200%20.02604%201.302%201.302)'%20fill='none'%20stroke='%23000'%20opacity='0.3'%3e%3ccircle%20cx='410.9'%20cy='410.9'%20r='410.9'%20color='%23000'%20overflow='visible'%20stroke-width='100'%20/%3e%3cpath%20d='M410.9%20223.2v375.4M598.6%20410.9H223.2'%20stroke-width='120'%20stroke-linecap='round'%20/%3e%3c/g%3e%3c/svg%3e";
const markerShadowUrl = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC";
function createIcon$1(colors) {
  let url = defaultIconDataUrl;
  for (const key of Object.keys(colors)) {
    url = url.replace(new RegExp(`%24%7b${key}%7d`, "g"), encodeURIComponent(colors[key]));
  }
  return new Icon.Default({ imagePath: new String(""), iconUrl: url, iconRetinaUrl: url, shadowUrl: markerShadowUrl });
}
const defaultIcon = createIcon$1({ color1: "#2e6c97", color2: "#3883b7", color3: "#126fc6", color4: "#4c9cd1" });
const startIcon = createIcon$1({ color1: "#2E9749", color2: "#06EA3F", color3: "#03D337", color4: "#40DD68" });
const endIcon = createIcon$1({ color1: "#972E2E", color2: "#B73838", color3: "#C61212", color4: "#D14C4C" });
const plusIcon = new Icon({
  iconUrl: plusIconDataUrl,
  iconSize: [24, 24],
  iconAnchor: [12, 12]
});
function locateOnLine(map, trackPoints, points, isPolygon = false) {
  const isFlat = L.LineUtil.isFlat(trackPoints);
  let normalizedTrackPoints = isFlat ? [trackPoints] : trackPoints;
  if (!normalizedTrackPoints.some((t) => t.length >= 2)) {
    throw new Error("Line doesn't have any track points.");
  }
  if (isPolygon) {
    normalizedTrackPoints = normalizedTrackPoints.map((trackPoints2) => [...trackPoints2, trackPoints2[0]]);
  }
  let maxzoom = map.getMaxZoom();
  if (maxzoom === Infinity) {
    maxzoom = map.getZoom();
  }
  const projectedPoints = (Array.isArray(points) ? points : [points]).map((point) => map.project(point, maxzoom));
  const data = [];
  for (let i = 0; i < normalizedTrackPoints.length; i++) {
    let pointA;
    let pointB = map.project(normalizedTrackPoints[i][0], maxzoom);
    for (let j = 1; j < normalizedTrackPoints[i].length; j++) {
      pointA = pointB;
      pointB = map.project(normalizedTrackPoints[i][j], maxzoom);
      for (let k = 0; k < projectedPoints.length; k++) {
        const point = projectedPoints[k];
        const sqDist = L.LineUtil._sqClosestPointOnSegment(point, pointA, pointB, true);
        if (data[k] == null || sqDist < data[k].sqDist) {
          data[k] = { sqDist, idx: [i, j - 1], point, pointA, pointB };
        }
      }
    }
  }
  const results = data.map((d) => {
    const closest = L.LineUtil.closestPointOnSegment(d.point, d.pointA, d.pointB);
    const idx = [d.idx[0], d.idx[1] + (closest.x - d.pointA.x) / (d.pointB.x - d.pointA.x)];
    return {
      idx: isFlat ? idx[1] : idx,
      closest: map.unproject(closest, maxzoom)
    };
  });
  return Array.isArray(points) ? results : results[0];
}
function getRouteInsertPosition(map, routePoints, trackPoints, point) {
  let pointIndex;
  let routePointIndexes;
  if (typeof routePoints[0] === "number") {
    pointIndex = typeof point === "number" ? point : locateOnLine(map, trackPoints, point).idx;
    routePointIndexes = routePoints;
  } else if (typeof point === "number") {
    pointIndex = point;
    routePointIndexes = locateOnLine(map, trackPoints, routePoints).map((r) => r.idx);
  } else {
    [pointIndex, ...routePointIndexes] = locateOnLine(map, trackPoints, [point, ...routePoints]).map((r) => r.idx);
  }
  for (let i = 1; i < routePointIndexes.length; i++) {
    if (routePointIndexes[i] > pointIndex)
      return i;
  }
  return routePointIndexes.length - 1;
}
function getFromPosition(arr, idx) {
  return Array.isArray(idx) ? arr[idx[0]][idx[1]] : arr[idx];
}
function insertAtPosition(arr, item, idx) {
  const idxArr = Array.isArray(idx) ? idx : [idx];
  if (idxArr.length === 0) {
    return arr;
  } else if (idxArr.length === 1) {
    return [...arr.slice(0, idxArr[0]), item, ...arr.slice(idxArr[0])];
  } else {
    const result = [...arr];
    result[idxArr[0]] = insertAtPosition(result[idxArr[0]], item, idxArr.slice(1));
    return result;
  }
}
function updateAtPosition(arr, item, idx) {
  const idxArr = Array.isArray(idx) ? idx : [idx];
  if (idxArr.length === 0) {
    return arr;
  } else if (idxArr.length === 1) {
    return [...arr.slice(0, idxArr[0]), item, ...arr.slice(idxArr[0] + 1)];
  } else {
    const result = [...arr];
    result[idxArr[0]] = updateAtPosition(result[idxArr[0]], item, idxArr.slice(1));
    return result;
  }
}
function removeFromPosition(arr, idx) {
  const idxArr = Array.isArray(idx) ? idx : [idx];
  if (idxArr.length === 0) {
    return arr;
  } else if (idxArr.length === 1) {
    return [...arr.slice(0, idxArr[0]), ...arr.slice(idxArr[0] + 1)];
  } else {
    const result = [...arr];
    result[idxArr[0]] = removeFromPosition(result[idxArr[0]], idxArr.slice(1));
    return result;
  }
}
function setPoint(layer, point, idx, insert) {
  const hasRoutePoints = layer.hasDraggableLinesRoutePoints();
  let points = hasRoutePoints ? layer.getDraggableLinesRoutePoints() : layer.getLatLngs();
  if (insert)
    points = insertAtPosition(points, point, idx);
  else
    points = updateAtPosition(points, point, idx);
  if (hasRoutePoints)
    layer.setDraggableLinesRoutePoints(points);
  else
    layer.setLatLngs(points);
}
function removePoint(layer, idx) {
  const hasRoutePoints = layer.hasDraggableLinesRoutePoints();
  let points = hasRoutePoints ? layer.getDraggableLinesRoutePoints() : layer.getLatLngs();
  points = removeFromPosition(points, idx);
  if (hasRoutePoints)
    layer.setDraggableLinesRoutePoints(points);
  else
    layer.setLatLngs(points);
}
function getPlusIconPoint(map, trackPoints, distance, atStart) {
  const tr = atStart ? trackPoints : [...trackPoints].reverse();
  const point0 = map.latLngToContainerPoint(tr[0]);
  const tr1 = tr.find((p, i) => i > 0 && point0.distanceTo(map.latLngToContainerPoint(p)) > 0);
  let result;
  if (!tr1) {
    result = L.point(point0.x + (atStart ? -1 : 1) * distance, point0.y);
  } else {
    const point1 = map.latLngToContainerPoint(tr1);
    const fraction = distance / point0.distanceTo(point1);
    result = L.point(point0.x - fraction * (point1.x - point0.x), point0.y - fraction * (point1.y - point0.y));
  }
  return map.containerPointToLatLng(result);
}
class DraggableLinesMarker extends Marker {
  constructor(draggable, layer, latlng, isInsert, options) {
    super(latlng, options);
    __publicField(this, "_draggable");
    __publicField(this, "_layer");
    __publicField(this, "_isInsert");
    __publicField(this, "_dragIdx");
    __publicField(this, "_dragFrom");
    this._draggable = draggable;
    this._layer = layer;
    this._isInsert = isInsert;
  }
  onAdd(map) {
    super.onAdd(map);
    this.on("dragstart", this.handleDragStart, this);
    this.on("drag", this.handleDrag, this);
    this.on("dragend", this.handleDragEnd, this);
    return this;
  }
  onRemove(map) {
    super.onRemove(map);
    return this;
  }
  handleDragStart(e) {
    const latlng = this.getLatLng();
    this._dragFrom = latlng;
    this._dragIdx = this.getIdx();
    setPoint(this._layer, latlng, this._dragIdx, this._isInsert);
    this._draggable.fire("dragstart", { layer: this._layer, from: latlng, to: latlng, idx: this._dragIdx, isNew: this._isInsert });
  }
  handleDrag() {
    const latlng = this.getLatLng();
    setPoint(this._layer, latlng, this._dragIdx, false);
    this._draggable.fire("drag", { layer: this._layer, from: this._dragFrom, to: latlng, idx: this._dragIdx, isNew: this._isInsert });
  }
  handleDragEnd() {
    const event = { layer: this._layer, from: this._dragFrom, to: this.getLatLng(), idx: this._dragIdx, isNew: this._isInsert };
    Promise.resolve().then(() => {
      setPoint(event.layer, event.to, event.idx, false);
      this._draggable.fire("dragend", event);
    });
  }
}
class DraggableLinesDragMarker extends DraggableLinesMarker {
  constructor(draggable, layer, latlng, idx, options, removeOnClick) {
    super(draggable, layer, latlng, false, {
      draggable: true,
      ...options
    });
    __publicField(this, "_idx");
    __publicField(this, "_removeOnClick");
    __publicField(this, "_over", false);
    this._idx = idx;
    this._removeOnClick = removeOnClick;
  }
  onAdd(map) {
    super.onAdd(map);
    const latlngs = this._layer.getDraggableLinesRoutePoints() || this._layer.getLatLngs();
    const points = Array.isArray(this._idx) ? latlngs[this._idx[0]] : latlngs;
    if (this._removeOnClick && points.length > (this._layer instanceof Polygon ? 3 : 2)) {
      this.on("click", this.handleClick);
    }
    this.on("mouseover", () => {
      if (Draggable._dragging)
        return;
      this._over = true;
      this._draggable.fire("dragmouseover", { layer: this._layer, idx: this._idx, marker: this });
    });
    this.on("mouseout", () => {
      if (Draggable._dragging)
        return;
      this._over = false;
      this._draggable.fire("dragmouseout", { layer: this._layer, idx: this._idx, marker: this });
    });
    return this;
  }
  onRemove(map) {
    super.onRemove(map);
    if (this._over)
      this._draggable.fire("dragmouseout", { layer: this._layer, idx: this._idx, marker: this });
    return this;
  }
  getIdx() {
    return this._idx;
  }
  handleClick() {
    const idx = this.getIdx();
    removePoint(this._layer, idx);
    this._draggable.fire("remove", { layer: this._layer, idx });
  }
}
function createIcon(layer, baseIcon) {
  const icon = Util.create(baseIcon);
  const _setIconStyles = icon._setIconStyles;
  icon._setIconStyles = (img, name) => {
    _setIconStyles.call(icon, img, name);
    const padding = layer.options.weight * 2;
    img.style.padding = `${padding}px`;
    img.style.boxSizing = "content-box";
    img.style.marginLeft = `${parseInt(img.style.marginLeft) - padding}px`;
    img.style.marginTop = `${parseInt(img.style.marginTop) - padding}px`;
    img.style.display = "none";
  };
  return icon;
}
class DraggableLinesTempMarker extends DraggableLinesMarker {
  constructor(draggable, layer, latlng, options) {
    super(draggable, layer, latlng, true, {
      draggable: true,
      zIndexOffset: -1e5,
      ...options,
      icon: createIcon(layer, options.icon)
    });
    __publicField(this, "renderPoint");
  }
  onAdd(map) {
    super.onAdd(map);
    map.on("mousemove", this.handleMapMouseMove, this);
    DomEvent.on(map.getContainer(), "mouseover", this.handleMapMouseOver, this);
    this.on("click", this.handleClick, this);
    this.updateLatLng(this.getLatLng());
    return this;
  }
  onRemove(map) {
    if (!this.isHidden())
      this.fireMouseOut();
    super.onRemove(map);
    map.off("mousemove", this.handleMapMouseMove, this);
    DomEvent.off(map.getContainer(), "mouseover", this.handleMapMouseOver, this);
    return this;
  }
  show() {
    this._icon.style.display = "";
    if (this._shadow)
      this._shadow.style.display = "";
    this.fireMouseOver();
  }
  hide() {
    this._icon.style.display = "none";
    if (this._shadow)
      this._shadow.style.display = "none";
    this.fireMouseOut();
  }
  isHidden() {
    return this._icon.style.display == "none";
  }
  getIdx() {
    if (!this.renderPoint) {
      throw new Error("renderPoint is not set");
    }
    return this.renderPoint.idx;
  }
  handleClick() {
    if (!this.renderPoint) {
      return;
    }
    const latlng = this.renderPoint.closest;
    const idx = this.renderPoint.idx;
    setPoint(this._layer, latlng, idx, true);
    this._draggable.fire("insert", { layer: this._layer, latlng, idx });
  }
  shouldRemove(mouseLatlng) {
    return !this._layer._containsPoint(this._map.latLngToLayerPoint(mouseLatlng));
  }
  // Overridden by DraggableLinesPlusTempMarker
  getRenderPoint(mouseLatLng) {
    const loc = locateOnLine(this._map, this._layer.getLatLngs(), mouseLatLng, this._layer instanceof Polygon);
    const distancePx = this._map.project(mouseLatLng).distanceTo(this._map.project(loc.closest));
    if (distancePx > this._layer.options.weight / 2 + 1)
      return void 0;
    let idx = this._layer.hasDraggableLinesRoutePoints() ? getRouteInsertPosition(this._map, this._draggable._getRoutePointIndexes(this._layer), this._layer.getLatLngs(), loc.idx) : Array.isArray(loc.idx) ? [loc.idx[0], Math.ceil(loc.idx[1])] : Math.ceil(loc.idx);
    return {
      closest: loc.closest,
      idx
    };
  }
  updateLatLng(mouseLatLng) {
    if (Draggable._dragging)
      return false;
    if (this.shouldRemove(mouseLatLng)) {
      this.remove();
      return false;
    }
    this.renderPoint = this.getRenderPoint(mouseLatLng);
    if (this.renderPoint)
      this.setLatLng(this.renderPoint.closest);
    const isVisible = !this.isHidden();
    if (this.renderPoint && !isVisible)
      this.show();
    else if (!this.renderPoint && isVisible)
      this.hide();
    else if (isVisible)
      this.fireMouseMove();
  }
  handleMapMouseMove(e) {
    this.updateLatLng(this._map.mouseEventToLatLng(e.originalEvent));
  }
  handleMapMouseOver(e) {
    if (!Draggable._dragging && e.target !== this.getElement() && e.target !== this._layer.getElement())
      this.remove();
  }
  fireMouseOver() {
    this._draggable.fire("tempmouseover", { layer: this._layer, idx: this.getIdx(), marker: this, latlng: this.getLatLng() });
  }
  fireMouseMove() {
    this._draggable.fire("tempmousemove", { layer: this._layer, idx: this.getIdx(), marker: this, latlng: this.getLatLng() });
  }
  fireMouseOut() {
    this._draggable.fire("tempmouseout", { layer: this._layer, marker: this });
  }
}
class DraggableLinesPlusMarker extends DraggableLinesMarker {
  constructor(draggable, layer, latlng, idx, options, tempMarkerOptions) {
    super(draggable, layer, latlng, true, {
      pane: "overlayPane",
      zIndexOffset: -2e5,
      ...options
    });
    __publicField(this, "_idx");
    __publicField(this, "_tempMarker");
    __publicField(this, "_tempMarkerOptions");
    this._idx = idx;
    this._tempMarkerOptions = tempMarkerOptions;
  }
  onAdd(map) {
    super.onAdd(map);
    this.on("mouseover", this.handleMouseOver, this);
    return this;
  }
  onRemove(map) {
    super.onRemove(map);
    if (this._tempMarker) {
      this._tempMarker.remove();
      delete this._tempMarker;
    }
    return this;
  }
  getIdx() {
    return this._idx;
  }
  handleMouseOver(e) {
    this._draggable.removeTempMarker();
    this._tempMarker = new DraggableLinesPlusTempMarker(this._draggable, this._layer, this, e.latlng, this.getIdx(), this._tempMarkerOptions).addTo(this._map);
    this._draggable._tempMarker = this._tempMarker;
  }
}
class DraggableLinesPlusTempMarker extends DraggableLinesTempMarker {
  constructor(draggable, layer, plusMarker, latlng, idx, options) {
    super(draggable, layer, latlng, options);
    __publicField(this, "_plusMarker");
    __publicField(this, "_idx");
    this._plusMarker = plusMarker;
    this._idx = idx;
  }
  shouldRemove(latlng) {
    const layerPoint = this._map.latLngToLayerPoint(latlng);
    const position = DomUtil.getPosition(this._plusMarker._icon);
    return Math.abs(position.y - layerPoint.y) > this._plusMarker._icon.offsetHeight / 2 || Math.abs(position.x - layerPoint.x) > this._plusMarker._icon.offsetWidth / 2;
  }
  getRenderPoint() {
    return { idx: this._idx, closest: this.getLatLng() };
  }
  fireMouseOver() {
    this._draggable.fire("plusmouseover", { layer: this._layer, idx: this.getIdx(), marker: this, plusMarker: this._plusMarker });
  }
  fireMouseMove() {
  }
  fireMouseOut() {
    this._draggable.fire("plusmouseout", { layer: this._layer, idx: this.getIdx(), marker: this, plusMarker: this._plusMarker });
  }
}
class DraggableLinesHandler extends (() => {
  function HandlerAndEvented(map) {
    Handler.call(this, map);
  }
  Object.setPrototypeOf(HandlerAndEvented.prototype, Handler.prototype);
  Object.assign(HandlerAndEvented.prototype, Evented.prototype);
  return HandlerAndEvented;
})() {
  constructor(map, options) {
    super(map);
    __publicField(this, "options");
    __publicField(this, "_tempMarker");
    __publicField(this, "handleLayerAdd", (e) => {
      if (e.layer instanceof Polyline && this.shouldEnableForLayer(e.layer))
        this.enableForLayer(e.layer);
    });
    __publicField(this, "handleLayerRemove", (e) => {
      if (e.layer instanceof Polyline)
        this.disableForLayer(e.layer);
    });
    __publicField(this, "handleLayerMouseOver", (e) => {
      if (Draggable._dragging)
        return;
      this.drawTempMarker(e.target, e.latlng);
    });
    __publicField(this, "handleLayerSetLatLngs", (e) => {
      const layer = e.target;
      if (!Draggable._dragging) {
        this.removeTempMarker();
        if (layer._draggableLines) {
          layer._draggableLines.routePointIndexes = void 0;
          this.drawDragMarkers(layer);
          this.drawPlusMarkers(layer);
        }
      }
    });
    this.options = {
      enableForLayer: (layer) => layer.options.interactive,
      allowExtendingLine: true,
      removeOnClick: true,
      ...options
    };
  }
  addHooks() {
    this._map.on("layeradd", this.handleLayerAdd);
    this._map.on("layerremove", this.handleLayerRemove);
    this._map.eachLayer((layer) => {
      this.handleLayerAdd({ layer });
    });
  }
  removeHooks() {
    this._map.on("layeradd", this.handleLayerAdd);
    this._map.on("layerremove", this.handleLayerRemove);
    this._map.eachLayer((layer) => {
      this.handleLayerRemove({ layer });
    });
  }
  shouldEnableForLayer(layer) {
    if (typeof this.options.enableForLayer === "function")
      return this.options.enableForLayer(layer);
    else if (typeof this.options.enableForLayer === "boolean")
      return this.options.enableForLayer;
    else if (Array.isArray(this.options.enableForLayer))
      return this.options.enableForLayer.includes(layer);
    else
      return this.options.enableForLayer === layer;
  }
  drawDragMarkers(layer) {
    var _a, _b;
    if (!layer._draggableLines)
      return;
    this.removeDragMarkers(layer);
    const latlngs = layer.getDraggableLinesRoutePoints() || layer.getLatLngs();
    const routePoints = LineUtil.isFlat(latlngs) ? [latlngs] : latlngs;
    const isFlat = LineUtil.isFlat(latlngs);
    for (let i = 0; i < routePoints.length; i++) {
      for (let j = 0; j < routePoints[i].length; j++) {
        const idx = isFlat ? j : [i, j];
        let removeOnClick = this.options.removeOnClick;
        const options = {
          icon: layer instanceof Polygon ? defaultIcon : j == 0 ? startIcon : j == routePoints[i].length - 1 ? endIcon : defaultIcon,
          ...(_b = (_a = this.options).dragMarkerOptions) == null ? void 0 : _b.call(_a, layer, j, routePoints[i].length)
        };
        const marker = new DraggableLinesDragMarker(this, layer, routePoints[i][j], idx, options, removeOnClick).addTo(this._map);
        layer._draggableLines.dragMarkers.push(marker);
      }
    }
  }
  removeDragMarkers(layer) {
    if (!layer._draggableLines)
      return;
    for (const marker of layer._draggableLines.dragMarkers) {
      marker.removeFrom(this._map);
    }
    layer._draggableLines.dragMarkers = [];
  }
  drawPlusMarkers(layer) {
    var _a, _b, _c, _d;
    this.removePlusMarkers(layer);
    if (layer instanceof Polygon || !layer._draggableLines || !this.options.allowExtendingLine)
      return;
    const latlngs = layer.getLatLngs();
    const trackPoints = LineUtil.isFlat(latlngs) ? [latlngs] : latlngs;
    const routePoints = layer.getDraggableLinesRoutePoints();
    for (let i = 0; i < trackPoints.length; i++) {
      if (trackPoints[i].length < 2)
        continue;
      for (const isStart of [true, false]) {
        let idx;
        if (routePoints)
          idx = isStart ? 0 : routePoints.length;
        else if (LineUtil.isFlat(latlngs))
          idx = isStart ? 0 : trackPoints[i].length;
        else
          idx = isStart ? [i, 0] : [i, trackPoints[i].length];
        const options = {
          icon: plusIcon,
          ...(_b = (_a = this.options).plusMarkerOptions) == null ? void 0 : _b.call(_a, layer, isStart)
        };
        const tempMarkerOptions = {
          icon: isStart ? startIcon : endIcon,
          ...(_d = (_c = this.options).plusTempMarkerOptions) == null ? void 0 : _d.call(_c, layer, isStart)
        };
        const marker = new DraggableLinesPlusMarker(this, layer, getPlusIconPoint(this._map, trackPoints[i], 24 + layer.options.weight / 2, isStart), idx, options, tempMarkerOptions).addTo(this._map);
        layer._draggableLines.plusMarkers.push(marker);
      }
    }
  }
  removePlusMarkers(layer) {
    if (!layer._draggableLines)
      return;
    for (const marker of layer._draggableLines.plusMarkers) {
      marker.removeFrom(this._map);
    }
    layer._draggableLines.plusMarkers = [];
  }
  drawTempMarker(layer, latlng) {
    var _a, _b;
    this.removeTempMarker();
    const options = {
      icon: defaultIcon,
      ...(_b = (_a = this.options).tempMarkerOptions) == null ? void 0 : _b.call(_a, layer)
    };
    this._tempMarker = new DraggableLinesTempMarker(this, layer, latlng, options).addTo(this._map);
  }
  removeTempMarker() {
    if (this._tempMarker) {
      this._tempMarker.removeFrom(this._map);
      delete this._tempMarker;
    }
  }
  enableForLayer(layer) {
    if (layer._draggableLines)
      return;
    layer._draggableLines = {
      dragMarkers: [],
      plusMarkers: [],
      zoomEndHandler: () => {
        this.drawPlusMarkers(layer);
      },
      routePointIndexes: void 0
    };
    layer.on("mouseover", this.handleLayerMouseOver);
    layer.on("draggableLines-setLatLngs", this.handleLayerSetLatLngs);
    layer.on("draggableLines-setRoutePoints", this.handleLayerSetLatLngs);
    this._map.on("zoomend", layer._draggableLines.zoomEndHandler);
    this.drawDragMarkers(layer);
    this.drawPlusMarkers(layer);
  }
  redrawForLayer(layer) {
    if (!layer._draggableLines)
      return;
    this.drawDragMarkers(layer);
    this.drawPlusMarkers(layer);
    if (this._tempMarker && this._tempMarker._layer === layer)
      this.drawTempMarker(layer, this._tempMarker.getLatLng());
  }
  disableForLayer(layer) {
    layer.off("mouseover", this.handleLayerMouseOver);
    layer.off("draggableLines-setLatLngs", this.handleLayerSetLatLngs);
    layer.off("draggableLines-setRoutePoints", this.handleLayerSetLatLngs);
    if (layer._draggableLines)
      this._map.off("zoomend", layer._draggableLines.zoomEndHandler);
    this.removeDragMarkers(layer);
    this.removePlusMarkers(layer);
    delete layer._draggableLines;
  }
  redraw() {
    this._map.eachLayer((layer) => {
      if (!(layer instanceof Polyline))
        return;
      const enable = this.shouldEnableForLayer(layer);
      if (layer._draggableLines && !enable)
        this.disableForLayer(layer);
      else if (!layer._draggableLines && enable)
        this.enableForLayer(layer);
      else if (layer._draggableLines)
        this.redrawForLayer(layer);
    });
  }
  _getRoutePointIndexes(layer) {
    if (!layer._draggableLines) {
      return void 0;
    } else if (!layer._draggableLines.routePointIndexes) {
      const routePoints = layer.getDraggableLinesRoutePoints();
      if (!routePoints) {
        return void 0;
      }
      const latlngs = layer.getLatLngs();
      layer._draggableLines.routePointIndexes = locateOnLine(this._map, [latlngs], routePoints).map((r) => r.idx[1]);
    }
    return layer._draggableLines.routePointIndexes;
  }
}
Polyline.prototype.hasDraggableLinesRoutePoints = function() {
  return this.options.draggableLinesRoutePoints != null;
};
Polyline.prototype.getDraggableLinesRoutePoints = function() {
  var _a;
  return (_a = this.options.draggableLinesRoutePoints) == null ? void 0 : _a.map((p) => latLng(p));
};
Polyline.prototype.setDraggableLinesRoutePoints = function(routePoints) {
  this.options.draggableLinesRoutePoints = routePoints;
  this.fire("draggableLines-setRoutePoints");
};
const setLatLngsBkp = Polyline.prototype.setLatLngs;
Polyline.prototype.setLatLngs = function(...args) {
  const result = setLatLngsBkp.apply(this, args);
  this.fire("draggableLines-setLatLngs");
  return result;
};
export {
  DraggableLinesDragMarker,
  DraggableLinesMarker,
  DraggableLinesPlusMarker,
  DraggableLinesPlusTempMarker,
  DraggableLinesTempMarker,
  DraggableLinesHandler as default,
  defaultIcon,
  endIcon,
  getFromPosition,
  getPlusIconPoint,
  getRouteInsertPosition,
  insertAtPosition,
  locateOnLine,
  plusIcon,
  removeFromPosition,
  removePoint,
  setPoint,
  startIcon,
  updateAtPosition
};
//# sourceMappingURL=L.DraggableLines.js.map
